module.exports = __webpack_public_path__ + "static/media/tracy_03.500b896a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/tracy_03.jpg
// module id = 381
// module chunks = 0